import React from 'react';
import { Link } from 'react-router-dom';
import './Navbar.css';

const Navbar = () => {
    return (
        <section class="sticky-top navbar_custom">
            <div className="container">
                <nav class="navbar navbar-expand-lg  navbar-light">
                    <Link to='/' className="navbar-brand brand_logo">MR</Link>
                    <button class="navbar-toggler" type="button" data-bs-toggle="collapse"      data-bs-target="#navbarSupportedContent" aria-controls="navbarSupportedContent" aria-expanded="false" aria-label="Toggle navigation">
                        <span class="navbar-toggler-icon"></span>
                    </button>
                    <div class="collapse navbar-collapse" id="navbarSupportedContent">
                        <ul class="navbar-nav ml-auto mb-2 mb-lg-0">
                            <li class="nav-item">
                                <a href="#home" className="nav-link active" aria-current="page">
                                    <span>Home</span>
                                </a>
                            </li>
                            <li class="nav-item">
                                <a href="#project" className="nav-link">
                                    <span>Projects</span>
                                </a>
                            </li>
                            <li class="nav-item">
                                <a href="#blog" className="nav-link">
                                    <span>Blogs</span>
                                </a>
                            </li>
                            <li class="nav-item">
                                <a href="#about" className="nav-link">
                                    <span>About</span>
                                </a>
                            </li>
                            <li class="nav-item">
                                <a href="#contact" className="nav-link">
                                    <span>Contact</span>
                                </a>
                            </li>
                            <li class="nav-item d-inline">
                                <a className="nav-link btn" href="https://drive.google.com/file/d/1Q7qjwPt6ec9gTh6pTdVnyJjcmp4F1ZuZ/view?usp=sharing" target="blank">Resume</a>
                            </li>
                        </ul>
                    </div>
                </nav>
            </div>
        </section>
    );
};

export default Navbar;